<script>
import options from './NewCarLoanCalculatorResult.options'
export default options
</script>

<template>
    <template v-if="isAdjustLoanOpen">
        <NewCarLoanCalculatorAdjustLoan
            :labelsInput="labelsInput"
            :labelsError="labelsError"
            :optionsInput="optionsInput"
            :onCloseCallBack="adjustLoanButtonCallback"
            :callback="onAdjustCallback"/>
    </template>


    <article class="nyk-new-car-loan-calculator-result">
        <div class="nyk-new-car-loan-calculator-result__info-container">

            <NewCarLoanCalculatorSummary
                :labels="labelsSummary"
                :data="data.summaryData"
                :callback="adjustLoanButtonCallback"
                />

            <CalculatorInfoBox 
                :data="infoBoxData"
                :styles="infoBoxStyles"/>

            <article class="nyk-new-car-loan-calculator-result__info-container-actions">
                <template v-for="(link, i) in links" :key="i">
                    <a v-if="link.link?.url || link.anchorId"
                        class="nyk-new-car-loan-calculator-summary__header--button nyk-button "
                        :class="link.type === 'primary' ? 'nyk-button--filled-primary' : 'nyk-button--outline-primary'"
                        :aria-label="link.ariaLabel"
                        :href="link.link?.url || ('#' + link.anchorId)"
                        :target="link.link?.target"
                        :rel="link.link?.target ? 'noopener' : null">
                        {{ link.label }}
                    </a>
                </template>
            </article>
        </div>
    </article>

    <section class="nyk-new-car-loan-calculator-result">
        <template v-for="(table, i) in tables" :key="i">
            <CalculatorTable
                :headers="table.header"
                :tooltip="table.tooltip"
                :collapse="false"
                :rows="table.rows"
                :labels="labelsTable"/>
        </template>
    </section>
</template>